import { useState } from 'react';

import { StratificationsFragments } from 'features/drilldown/Stratifications';
import { StratKey } from 'features/drilldown/Stratifications/startifications.config';
import { StratCard } from 'features/drilldown/Stratifications/StratCard';
import { StratsSelection } from 'features/drilldown/Stratifications/StratsSelection';
import { PoolSummaryFragments } from 'features/loanPool/PoolSummary';

import { gql } from '@apollo/client';

import { ListingStratsCardListing } from './__generated__/ListingStratsCardListing';
import { CardWrapper } from './CardWrapper';
import { SpinnerComponent } from '../../../ui-kit';

const ListingStratsCardFragments = {
  listing: gql`
    fragment ListingStratsCardListing on Listing {
      id
      assetClass: asset_class
      performanceData: performance_summary {
        ...PoolSummaryPerformanceSummary
        ...StratificationsPerformanceSummary
      }
    }
    ${PoolSummaryFragments.performanceSummary}
    ${StratificationsFragments.performanceSummary}
  `,
};

type StartsCardProps = ListingStratsCardListing & {
  loading: boolean;
};

function ListingStratsCard(props: StartsCardProps) {
  const [strats, setStrats] = useState<StratKey[]>([]);

  return (
    <CardWrapper {...props} onClick={() => null} dealId={''} active={true} name={'strats'}>
      {!props.loading ? (
        <>
          <StratsSelection selectedStrats={strats} onSelectedStratsChange={setStrats} />
          <div
            className="mt-2 flex flex-wrap gap-2
        [&>*]:max-h-[700px]
        [&>*]:min-w-full
        [&>*]:flex-1
        [&>*]:lg:min-w-[calc(50%-0.5rem)]
        [&>*]:2xl:min-w-[calc(33.333%-0.5rem)]"
          >
            {strats.map((strat) => (
              <StratCard
                key={strat}
                strat={strat}
                assetClass={props.assetClass}
                summary={props.performanceData}
                avgSummary={props.performanceData}
              />
            ))}
          </div>
        </>
      ) : null}
      <SpinnerComponent loading={props.loading} positionRelative={true} />
    </CardWrapper>
  );
}

export default ListingStratsCard;

export { ListingStratsCardFragments };
